module.exports = __webpack_public_path__ + "img/GO-Hi rgb logo.caf18dbe.svg";